import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { AppThunkDispatch } from "@/store";
import { toast } from "react-toastify";
import actionsHandler from "@/store/actions/actionHandler";

interface TermsAndConditionsProps {
  onClose: () => void;
  user_type: number;
}

interface CMSPage {
  id: number;
  title: string;
  slug: string;
  content: string;
  is_archive: boolean;
  user_type: number;
  created_at: string;
  updated_at: string;
  deleted_at: string | null;
}

const TermsAndConditions = ({
  onClose,
  user_type,
}: TermsAndConditionsProps) => {
  const dispatch = useDispatch<AppThunkDispatch>();
  const [isLoading, setIsLoading] = useState(true);
  const [termsContent, setTermsContent] = useState<CMSPage[]>([]);

  useEffect(() => {
    const fetchTermsContent = async () => {
      try {
        const { unAuthenticatedCall } = actionsHandler("cmsPageList");
        const response = await dispatch(
          unAuthenticatedCall({
            customQuery: `user_type=${user_type}`,
            method: "get",
          }),
        );

        if (response.ok) {
          setTermsContent(response.data);
        } else {
          toast.error("Failed to load terms and conditions");
        }
      } catch (error) {
        console.error("Error fetching terms content:", error);
        toast.error("An error occurred while loading terms and conditions");
      } finally {
        setIsLoading(false);
      }
    };

    fetchTermsContent();
  }, [dispatch, user_type]);

  return (
    <div>
      <div className="tw-fixed tw-inset-0 tw-bg-black/25 tw-flex tw-items-center tw-justify-center tw-z-50">
        <div className="tw-bg-white tw-w-screen tw-h-screen tw-overflow-y-auto tw-relative">
          <div className="tw-fixed tw-w-full tw-top-0 tw-mb-6 tw-bg-white tw-z-10">
            <div className="tw-flex tw-justify-center tw-items-center tw-p-6">
              <img
                src="/logo/Logo.svg"
                alt="Logo"
                className="tw-mx-auto tw-max-w-[150px]"
              />
            </div>
            <div className="tw-bg-[#F8FAFC]">
              <p className="text-primary-color font-weight-semibold tw-py-6 tw-ml-6 tw-text-[22px] leading-6">
                Terms & Conditions
              </p>
            </div>
          </div>

          <div className="tw-mt-[200px] tw-px-6">
            {isLoading ? (
              <div className="tw-flex tw-justify-center tw-items-center tw-h-[200px]">
                <p>Loading terms and conditions...</p>
              </div>
            ) : (
              <div className="tw-space-y-6">
                {termsContent.map((page) => (
                  <div key={page.id} className="tw-mb-8">
                    <h2 className="text-primary-color font-weight-semibold tw-py-2 font-size-base leading-6">
                      {page.title}
                    </h2>
                    <div
                      className="tw-prose tw-max-w-none"
                      dangerouslySetInnerHTML={{ __html: page.content }}
                    />
                  </div>
                ))}
              </div>
            )}
          </div>

          <div className="tw-sticky tw-bottom-0 tw-bg-white tw-p-5 tw-border-t tw-border-gray-200">
            <div className="tw-flex tw-justify-center tw-items-center">
              <button
                onClick={onClose}
                disabled={isLoading}
                className="tw-py-2 primary-custom-button disabled:tw-opacity-50"
              >
                I Accept to Terms & Conditions
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
